import type { PushPermission } from 'src/entities/push'
import { defineStore } from 'pinia'

interface IStatePush {
  /** Пуши включены в приложении (переключатель); выключено — устройство убрано из notifire. */
  enabled: boolean
  /** Разрешение в системе телефона; null — обёртка его не сообщает (старая версия) или ещё не узнали. */
  permission: PushPermission | null
}

export const usePushStore = defineStore('push', {
  state: (): IStatePush => ({
    enabled: true,
    permission: null,
  }),
  actions: {
    setEnabled(value: boolean) {
      this.enabled = value
    },
    setPermission(value: PushPermission) {
      this.permission = value
    },
  },
  // выбор продавца на этом устройстве; разрешение каждый раз спрашивается у обёртки
  persist: {
    pick: ['enabled'],
  },
})
